"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var auth = __importStar(require("../../helpers/auth"));
var AvatarSvg_1 = __importDefault(require("./AvatarSvg"));
var HexColors_1 = __importDefault(require("../../constants/HexColors"));
var Loader_1 = __importDefault(require("../Button/Loader"));
var resolveColor = function (name) {
    var firstLetter = name.toLowerCase().substring(0, 1);
    var alphabet = 'abcdefghijklmnopqrstuvwxyz';
    var letter = alphabet[Math.floor(Math.random() * alphabet.length)];
    return HexColors_1.default[firstLetter] || HexColors_1.default[letter];
};
var composeContent = function (img, name) {
    if (img) {
        return react_1.default.createElement("img", { src: img, alt: "", className: "avatar" });
    }
    if (name) {
        return (react_1.default.createElement("div", { className: "profile-first-letter", style: {
                backgroundColor: resolveColor(name).backgroundColor,
            } }, name.toUpperCase().substring(0, 1)));
    }
    return (react_1.default.createElement("div", { className: "default-avatar" },
        react_1.default.createElement(AvatarSvg_1.default, { authenticated: auth.isAuthenticated() })));
};
var Avatar = function (_a) {
    var onClick = _a.onClick, img = _a.img, name = _a.name, style = _a.style, _b = _a.loader, loader = _b === void 0 ? false : _b;
    return (react_1.default.createElement("div", { className: "avatar-wrapper", onClick: onClick, style: style },
        loader && (react_1.default.createElement("div", { className: "avatar-loader" },
            react_1.default.createElement(Loader_1.default, null))),
        composeContent(img, name)));
};
exports.default = Avatar;
